import PropTypes from "prop-types";
import React from "react";
import { SmallBox } from "view/layout/small-box";

class DeviceStatsBox extends React.PureComponent {
  static get propTypes() {
    return {
      deviceStatusOnline: PropTypes.bool,
      deviceStats: PropTypes.object.isRequired,
      isOnlinePanel: PropTypes.bool.isRequired,
    };
  }

  renderDescription(deviceStats, isOnlinePanel) {
    const {
      percentOffline,
      percentOnline,
      prodHibernating,
      sandboxHibernating,
      sandboxOffline,
      sandboxOnline,
    } = deviceStats;

    let mainText;
    let detailText;
    let smallTitle;
    if (isOnlinePanel) {
      mainText = `${percentOnline}% of prod devices are online`;
      detailText =
        `${prodHibernating} hibernating; ${sandboxOnline} sandbox ` +
        "devices online";
      smallTitle =
        `${prodHibernating} production devices hibernating. ` +
        `${sandboxOnline} sandbox devices online, ${sandboxHibernating} ` +
        "hibernating.";
    } else {
      mainText = `${percentOffline}% of prod devices are offline`;
      detailText = `${sandboxOffline} sandbox devices offline`;
    }

    return (
      <div>
        <p>
          <span>{mainText}</span>
          <small title={smallTitle}>{detailText}</small>
        </p>
      </div>
    );
  }

  getConfig(stats, isOnlinePanel) {
    const config = {
      color: "red",
      icon: "arrow-down",
      onOffCount: stats.prodOffline,
      title: undefined,
    };

    if (isOnlinePanel) {
      config.color = "green";
      config.icon = "arrow-up";
      config.onOffCount = stats.prodOnline;
      config.title =
        `${stats.prodOnline} production devices online, ` +
        `${stats.prodHibernating} hibernating.`;
    }

    return config;
  }

  render() {
    const { deviceStats, deviceStatusOnline, isOnlinePanel } = this.props;

    const config = this.getConfig(deviceStats, isOnlinePanel);
    const description = this.renderDescription(deviceStats, isOnlinePanel);
    const offlineClass =
      deviceStatusOnline === false
        ? "online-component offline"
        : "online-component";

    return (
      <SmallBox
        boxTitle={String(config.onOffCount)}
        className={offlineClass}
        title={config.title}
        desc={description}
        color={config.color}
        icon={config.icon}
      />
    );
  }
}

export { DeviceStatsBox };
